export enum ShoppingCartItemEnum {
	TRADE_IN = "old-swap-device",
	PAYMENT = "agreement",
	DELIVERY = "delivery-details",
	HARDWARE = "hardware",
	CONTACT = "contact-information",
	INSURANCE = "insurance-information",
}
